// Recent searches — the frontend side of /api/recent-queries
// (modules/zebra-search/recent-queries/server). Per account, per place.
//
// copyUpOnce(scope, localKey): the lists used to live in this browser only
// (localStorage). The first time a place is opened after the move, whatever
// this browser kept is copied up to the account, once — a marker in the same
// storage says it is done, and the old list is left where it was.

import { client } from '@platform/http/api-client';

const recentQueries = {
  async list(scope) {
    const r = await client.get('/api/recent-queries', { params: { scope } });
    return ((r.data && r.data.queries) || []).map((q) => q.query);
  },
  async record(scope, query) {
    const r = await client.post('/api/recent-queries', { scope, query });
    return ((r.data && r.data.queries) || []).map((q) => q.query);
  },
  async copyUpOnce(scope, localKey) {
    const done = `${localKey}:copied-to-account`;
    let local = [];
    try { if (localStorage.getItem(done)) return null; local = JSON.parse(localStorage.getItem(localKey) || '[]'); } catch { return null; }
    if (!Array.isArray(local) || !local.length) { try { localStorage.setItem(done, '1'); } catch { /* storage may be blocked */ } return null; }
    const r = await client.post('/api/recent-queries/import', { scope, queries: local });
    try { localStorage.setItem(done, '1'); } catch { /* storage may be blocked */ }
    return ((r.data && r.data.queries) || []).map((q) => q.query);
  },
};

export default recentQueries;
